import React from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import PopUp from '../../pages/PopUp';


const Footer = () => {
  return (
    <>
      <footer className="main-footer footer-v1 pt-80">
        <div className="container">
          <div className="footer-widget-area pt-80 pb-30">
            <div className="row" style={{ marginTop: "-90px" }}>
              <div className="col-lg-3 col-md-6">
                {/*=== Footer Widget ===*/}
                <div className="footer-widget footer-about-widget mb-40 aos-init" data-aos-duration={800}>
                  <div className="widget-content">
                    <div className="footer-logo mb-30">
                      <Link to="/"><img src="assets/img/Earth_1.webp" alt="Brand Logo" /></Link>
                    </div>
                    {/* <p>Renviais a trusted real estate group specializing  residential, commercial, investment properties commitment.</p> */}
                    <div className="social-box">
                      <Link to="https://www.facebook.com/earthbondproperty/?ref=NONE_xav_ig_profile_page_web#" target='_blank'><i className="fab fa-facebook-f" /></Link>
                      <Link to="https://www.instagram.com/earth_bond_property/" target='_blank'><i className="fab fa-instagram" /></Link>
                      <Link to="https://www.youtube.com/@earthbondproperty" target='_blank'><i className="fab fa-youtube" /></Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                {/*=== Footer Widget ===*/}
                <div className="footer-widget footer-nav-widget mb-40 ms-0 ms-lg-5 aos-init" data-aos-duration={1000}>
                  <div className="widget-content">
                    <h4 className="widget-title">Quick Links</h4>
                    <div className="line-wrap"><span /><span /><span /></div>
                    <ul className="widget-nav">
                      <li><Link to="/">Home</Link></li>
                      <li><Link to="/about-us">About Us</Link></li>
                      <li><Link to="/our-gallery">Our Gallery</Link></li>
                      <li><Link to="/contact-us">Contact Us</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                {/*=== Footer Widget ===*/}
                <div className="footer-widget footer-nav-widget mb-40 aos-init" data-aos-duration={1200}>
                  <div className="widget-content">
                    <h4 className="widget-title">Our Project</h4>
                    <div className="line-wrap"><span /><span /><span /></div>
                    <ul className="widget-nav">
                      <li><a to="service-details.html">Current Projects</a></li>
                      <li><a to="service-details.html">Ongoing Projects</a></li>
                      <li><a to="service-details.html">Complete Projects</a></li>
                      <li><a to="service-details.html">Residential Property</a></li>
                      <li><a to="service-details.html">Commercial Property</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                {/*=== Footer Widget ===*/}
                <div className="footer-widget footer-newsletter-widget mb-40 aos-init" data-aos-duration={1400}>
                  <div className="widget-content">
                    <h4 className="widget-title">Google Map</h4>
                    <div className="line-wrap"><span /><span /><span /></div>
                    <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=400&height=200&hl=en&q=2880 Broadway, NewEarth Bond Satna, &t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">google maps embed</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:200px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:200px;}.gmap_iframe {height:200px!important;}" }} /></div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*=== Copyright Area ===*/}
          <div className="copyright-area">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright-text text-lg-start text-center" style={{ textAlign: "center" }}>
                  <p style={{ textAlign: "center" }}>© 2026 Earth Bond Property | <a href="tel:+91 8982471422">Designed by Web solution & digital marketing</a></p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </footer>


      <PopUp />
      <WhatsappIcon />
    </>
  )
}

export default Footer